import { createContext, useContext } from 'react';

/** The one-company app, or the cross-company management section (the CRM pages). */
export type Section = 'app' | 'management';

/**
 * Carries which section the current route belongs to, so the shared layout can pick the menu and the nav footer
 * from the route scope rather than from the viewer's role: a Root user on `/trips` is in the app, on `/management` in
 * management.
 */
export const SectionContext = createContext<Section>('app');

/** The section the current route belongs to. Every route outside the management scope reads `app`. */
export function useSection(): Section {
  return useContext(SectionContext);
}

/** Path prefix of every management route, for code outside the router tree that needs to know the section. */
const MANAGEMENT_PATH_PREFIX = '/management';

/** Whether a path belongs to the management section, as the `management` route scope does. */
export function isManagementPath(pathname: string): boolean {
  return pathname === MANAGEMENT_PATH_PREFIX || pathname.startsWith(`${MANAGEMENT_PATH_PREFIX}/`);
}
